export enum Color {
  PRIMARY = '#2c74f3',
  SECONDARY = '#003d7c',
  DANGER = '#e51742',
}
